import { defineNuxtPlugin } from '#app';
import anime from 'animejs';

const plugin = defineNuxtPlugin(() => ({
  provide: { anime }
}));

export { plugin as default };
